import z from "zod";

export const athenaHealthAuthPath = "/athena/app";
export const canvasAuthPath = "/canvas/app";
export const elationAuthPath = "/elation/app";
export const healthieAuthPath = "/healthie/app";
export const eclinicalworksAuthPath = "/eclinicalworks/app";
export const salesforceAuthPath = "/salesforce/app";
export const practicefusionAuthPath = "/practicefusion/app";
export const embedAuthPath = "/embed/app";

export const authPaths = [
  athenaHealthAuthPath,
  canvasAuthPath,
  elationAuthPath,
  healthieAuthPath,
  eclinicalworksAuthPath,
  salesforceAuthPath,
  practicefusionAuthPath,
  embedAuthPath,
];

export const authPathSchema = z.object({
  authPath: z.enum(authPaths as [string, ...string[]]),
});
export type EhrAuthPath = z.infer<typeof authPathSchema>;
